import React from 'react';
import { Link } from 'react-router-dom';

function PostEncounterMsgWidget() {
  return (
    <>
      <div className="chart-rt-sec-rt-rw grid-sec">
        <div className="chrt-doc-sec-nm flex-sec">
          lorem ipsum lorem lorem lorem ipsum lorem lorem
        </div>
        <div className="chrt-doc-sec-dt flex-sec sec-colr">
          <span className="">Assigned to: K Verma</span>
        </div>
        <div className="chrt-doc-sec-dt flex-sec sec-colr">
          <span className="">Added by: M Kashif [07-05-2023]</span>
        </div>
        <div className="chrt-doc-sec-dt flex-sec">
          <span className="">
            <Link className="">Change</Link>
          </span>
          <span className="red clear-right clear-left10">|</span>
          <span className="">
            <Link className="">Delete</Link>
          </span>
          <span className="red clear-right clear-left10 ">|</span>
          <span className="">
            <Link className="">Reply</Link>
          </span>
        </div>
      </div>
      <div className="chart-rt-sec-rt-rw grid-sec alt-rw">
        <div className="chrt-doc-sec-nm flex-sec">
          lorem ipsum lorem lorem lorem ipsum lorem lorem
        </div>
        <div className="chrt-doc-sec-dt flex-sec sec-colr">
          <span className="">Assigned to: K Verma</span>
        </div>
        <div className="chrt-doc-sec-dt flex-sec sec-colr">
          <span className="">Added by: M Kashif [07-05-2023]</span>
        </div>
        <div className="chrt-doc-sec-dt flex-sec">
          <span className="">
            <Link className="">Change</Link>
          </span>
          <span className="red clear-right clear-left10 ">|</span>
          <span className="">
            <Link className="">Delete</Link>
          </span>
          <span className="red clear-right clear-left10 ">|</span>
          <span className="">
            <Link className="">Reply</Link>
          </span>
        </div>
      </div>
      <div className="chart-rt-sec-rt-rw grid-sec">
        <div className="chrt-doc-sec-nm flex-sec">
          lorem ipsum lorem lorem lorem ipsum lorem lorem
        </div>
        <div className="chrt-doc-sec-dt flex-sec sec-colr">
          <span className="">Assigned to: K Verma</span>
        </div>
        <div className="chrt-doc-sec-dt flex-sec sec-colr">
          <span className="">Added by: M Kashif [07-05-2023]</span>
        </div>
        <div className="chrt-doc-sec-dt flex-sec">
          <span className="">
            <Link className="">Change</Link>
          </span>
          <span className="red clear-right clear-left10 ">|</span>
          <span className="">
            <Link className="">Delete</Link>
          </span>
          <span className="red clear-right clear-left10 ">|</span>
          <span className="">
            <Link className="">Reply</Link>
          </span>
        </div>
      </div>
    </>
  );
}

export default PostEncounterMsgWidget;
